"use client";

import React from "react";
import { NavProvider } from "./NavContext";
import DesktopNavigation from "./DesktopNavigation";
import MobileNavigation from "./MobileNavigation";
import { AnnouncementBar } from "./AnnouncementBar";

const Navbar: React.FC = () => {
  return (
    <NavProvider>
      <AnnouncementBar />
      <header role="banner" className="w-full">
        <nav aria-label="Main Navigation" className="p-6 lg:p-12">
          <div className="container mx-auto flex justify-between items-center">
            <DesktopNavigation />
            <MobileNavigation />
          </div>
        </nav>
      </header>
    </NavProvider>
  );
};

Navbar.displayName = "Navbar";
export default Navbar;
